
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/getting-started",
      function () {
        return require("private-next-pages/school/getting-started.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/getting-started"])
      });
    }
  